import { FACETS, getFacetOptions } from '@/lib/filters';
import { humanize } from '@/lib/humanize';

export default function FiltersPanel({ papers, filters, onToggle, onClear }) {
  const hasActive = Object.values(filters).some((v) => v && v.length > 0);

  return (
    <div className="filters-panel">
      <div className="filters-panel__header">
        <h2 className="filters-panel__title">Filters</h2>
        {hasActive && (
          <button className="btn btn--ghost btn--sm" onClick={onClear} type="button">
            Clear all
          </button>
        )}
      </div>
      <div className="filters-panel__grid">
        {FACETS.map((facet) => {
          const options = getFacetOptions(papers, facet);
          if (options.length === 0) return null;
          const selected = filters[facet.key] || [];
          return (
            <div className="filters-panel__group" key={facet.key}>
              <label className="filters-panel__label">{facet.label}</label>
              <div className="filters-panel__chips">
                {options.map(({ value, count }) => (
                  <button
                    key={value}
                    type="button"
                    className={`filter-chip ${selected.includes(value) ? 'filter-chip--active' : ''}`}
                    onClick={() => onToggle(facet.key, value)}
                    aria-pressed={selected.includes(value)}
                  >
                    {humanize(value)} <span className="filter-chip__count">{count}</span>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
